import { hex2rgb, shade } from './string'
import { ensureAaOnWhite, mix, readableTextOn, toRgbTriplet } from '../utils/brandColor'

export const JSON_TREE_THEME = {
  base00: '#272822',
  base01: '#383830',
  base02: '#49483e',
  base03: '#75715e',
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: '#f9f8f5',
  base08: '#f92672',
  base09: '#fd971f',
  base0A: '#f4bf75',
  base0B: '#a6e22e',
  base0C: '#a1efe4',
  base0D: '#66d9ef',
  base0E: '#ae81ff',
  base0F: '#cc6633',
}

// Every property setCompanyStyle may write, so resetCompanyStyle can take them all back.
const COMPANY_STYLE_PROPERTIES = [
  '--cui-primary',
  '--cui-sidebar-nav-link-active-color',
  '--cui-btn-bg',
  '--cui-primary-start',
  '--cui-primary-rgb',
  '--cui-link-color-rgb',
  '--cui-link-hover-color-rgb',
  '--cui-secondary',
  '--cui-primary-stop',
  '--brand-primary',
  '--brand-primary-rgb',
  '--brand-primary-hover',
  '--brand-on-primary',
  '--brand-link',
  '--brand-secondary',
  '--brand-secondary-rgb',
]

export function setCompanyStyle(company) {
  if (!company) return
  const { color2 } = company
  const root = document.documentElement

  if (company.color1) {
    // The app's own colours stay exactly the airline's colour (passenger pages and the signed-in
    // app look as they always have).
    const { color1 } = company
    const primaryHex = hex2rgb(color1)
    ;[
      '--cui-primary',
      '--cui-sidebar-nav-link-active-color',
      '--cui-btn-bg',
      '--cui-primary-start',
    ].forEach((variable) => root.style.setProperty(variable, color1))
    ;['--cui-primary-rgb', '--cui-link-color-rgb'].forEach((variable) =>
      root.style.setProperty(variable, primaryHex),
    )
    root.style.setProperty('--cui-link-hover-color-rgb', hex2rgb(shade(color1, -20)))

    // Sign-in pages (AuthShell) use the airline's EXACT colour for the card header and buttons.
    // Text on it is white, as on the airlines' own sites (e.g. Air Transat light blue, 2.4:1);
    // only a very pale colour (below 2:1, e.g. yellow or pastel) gets near-black text instead. Small text links on white use --brand-link, darkened only if needed for 4.5:1.
    root.style.setProperty('--brand-primary', color1)
    root.style.setProperty('--brand-primary-rgb', primaryHex)
    root.style.setProperty('--brand-primary-hover', mix(color1, -0.12))
    root.style.setProperty('--brand-on-primary', readableTextOn(color1, { min: 2 }))
    root.style.setProperty('--brand-link', ensureAaOnWhite(color1, { min: 4.5 }))
  }

  if (color2) {
    ;['--cui-secondary', '--cui-primary-stop', '--brand-secondary'].forEach((variable) =>
      root.style.setProperty(variable, color2),
    )
    const secondaryRgb = toRgbTriplet(color2)
    if (secondaryRgb) root.style.setProperty('--brand-secondary-rgb', secondaryRgb)
  }
}

/** Removes everything setCompanyStyle set, returning the page to the Vamos stylesheet colours. */
export function resetCompanyStyle() {
  const root = document.documentElement
  COMPANY_STYLE_PROPERTIES.forEach((variable) => root.style.removeProperty(variable))
}
